import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'project-admin-notifications',
  template: `
<div class="tab-content">
  <div role="tabpanel" class="tab-pane active" id="project-admin-notification-tab">
    <div class="col-xs-12">
      <h4 translate>Send New Notification</h4>
      <gf-send-notification [project]="project" [context]="'project'"></gf-send-notification>
    </div>
  </div>
</div>`
})
export class ProjectAdminNotificationsComponent implements OnInit {
  @Input() project: any;

  constructor() { }

  ngOnInit(): void { }
}
